import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";
import { ETHNICITIES, AGE_RANGES, BODY_TYPES } from '@/constants';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Obter label de etnia pelo id
 */
export function getEthnicityLabel(id: string | null): string {
  if (!id) return '';
  return ETHNICITIES.find(e => e.id === id)?.label || id;
}

/**
 * Obter label de faixa etária pelo id
 */
export function getAgeRangeLabel(id: string | null): string {
  if (!id) return '';
  return AGE_RANGES.find(a => a.id === id)?.label || id;
}

/**
 * Obter label de tipo de corpo pelo id
 */
export function getBodyTypeLabel(id: string | null): string {
  if (!id) return '';
  return BODY_TYPES.find(b => b.id === id)?.label || id;
}

/**
 * Formatar link do WhatsApp com mensagem pré-preenchida
 */
export function formatWhatsAppLink(
  whatsapp: string, 
  productName: string, 
  price: number, 
  sku?: string | null
): string {
  let phone = whatsapp.replace(/\D/g, '');

  // Adicionar código do Brasil se não estiver presente
  if (!phone.startsWith('55')) {
    phone = '55' + phone;
  }

  const formattedPrice = formatPrice(price);

  const productInfo = sku 
    ? `"${productName}" (Cód: ${sku})`
    : `"${productName}"`;

  const message = encodeURIComponent(
    `Olá! Tenho interesse no produto ${productInfo} por ${formattedPrice}. Poderia me dar mais informações?`
  );

  return `https://api.whatsapp.com/send/?phone=${phone}&text=${message}&type=phone_number&app_absent=0`;
}

/**
 * Ajustar brilho de cor hexadecimal
 */
export function adjustColorBrightness(hex: string, percent: number): string {
  const num = parseInt(hex.replace('#', ''), 16);
  const amt = Math.round(2.55 * percent);
  const R = (num >> 16) + amt;
  const G = (num >> 8 & 0x00FF) + amt;
  const B = (num & 0x0000FF) + amt;

  return '#' + (
    0x1000000 +
    (R < 255 ? (R < 1 ? 0 : R) : 255) * 0x10000 +
    (G < 255 ? (G < 1 ? 0 : G) : 255) * 0x100 +
    (B < 255 ? (B < 1 ? 0 : B) : 255)
  ).toString(16).slice(1);
}

/**
 * Formatar preço em BRL
 */
export function formatPrice(value: number): string {
  return new Intl.NumberFormat('pt-BR', { 
    style: 'currency', 
    currency: 'BRL' 
  }).format(value);
}
